<template>
  <component
    :is="isDialog ? 'q-dialog' : 'div'"
    v-model="shown"
    data-test-id="kiosk-login"
  >
    <q-card
      v-bind="$attrs"
    >
      <q-card-section
        v-if="isDialog"
        class="full-width row items-center q-px-none q-pt-none"
        :class="{ 'justify-end': !requestCode, 'justify-between': requestCode }"
      >
        <q-btn
          v-if="requestCode"
          icon="fas fa-arrow-left"
          flat
          round
          dense
          @click="$emit('code-sent', false)"
        />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>

      <slot name="header" />

      <one-time-code-login
        v-if="useOneTimeCodeLogin"
        flat
        class="bg-transparent full-width"
        :request-code="requestCode"
        :button-padding="$isLandscapeView() ? '1vw 2vw' : '1vh 2vh'"
        :tab-button-padding="$isLandscapeView() ? '0.5vw 1vw' : '0.5vh 1vh'"
        @code-sent="(val) => $emit('code-sent', val)"
        @login-success="(userId) => $emit('login-success', userId)"
      />
      <login
        v-else
        flat
        hide-register-button
        class="bg-transparent full-width"
        dense
        kiosk-login
        hide-forgot-password-button
        :button-padding="$isLandscapeView() ? '1vw 2vw' : '1vh 2vh'"
        @login-success="(userId) => $emit('login-success', userId)"
      >
        <template #header>
          <div />
        </template>
      </login>
      <q-btn
        v-if="showLoginMethodToggle"
        :padding="$isLandscapeView() ? '0.5vw 1vw' : '0.5vh 1vh'"
        flat
        :size="$isLandscapeView() ? '1.4vw' : '1.8vh'"
        class="text-underline text-weight-regular text-capitalize full-width"
        @click="clickLoginMethodToggle"
      >
        {{ linkText }}
      </q-btn>

      <slot name="footer" />
    </q-card>
  </component>
</template>

<script>

import { email, required } from '@vuelidate/validators'
import Login from 'src/modules/auth/pages/Login'
import OneTimeCodeLogin from 'src/modules/auth/pages/OneTimeCodeLogin'
import InternalOrExternalLink from 'src/modules/consumer/components/InternalOrExternalLink'
export default {
  name: 'KioskLogin',
  components: {
    Login,
    InternalOrExternalLink,
    OneTimeCodeLogin
  },
  inject: ['order'],
  props: {
    isDialog: {
      type: Boolean,
      required: false,
      default: false
    },
    requestCode: {
      type: Boolean,
      required: false,
      default: false
    },
    showLoginMethodToggle: {
      type: Boolean,
      required: false,
      default: false
    },
    overrideUseOneTimeCodeLogin: {
      type: Boolean,
      required: false,
      default: null
    }
  },
  emits: ['action-selected', 'code-sent', 'login-success', 'toggle-login-method'],
  data () {
    return {
      shown: false,
      useOneTimeCodeLogin: this.currentCircuit.kioskOptions.enable_one_time_code_login
    }
  },
  computed: {
    linkText () {
      if (!this.useOneTimeCodeLogin) {
        return this.$t('auth.actions.loginWithOneTimeCode')
      }

      return this.$t('auth.actions.loginWithEmail')
    }
  },
  watch: {
    overrideUseOneTimeCodeLogin: {
      handler (val) {
        if (val !== null) {
          this.useOneTimeCodeLogin = val
        }
      },
      immediate: true
    }
  },
  created () {
    _.extend(this, {
      required,
      email
    })
  },
  methods: {
    show () {
      this.shown = true
    },
    hide () {
      this.shown = false
    },
    clickLoginMethodToggle () {
      this.useOneTimeCodeLogin = !this.useOneTimeCodeLogin
      this.$emit('toggle-login-method', this.useOneTimeCodeLogin)
    }
  },
  configuration: ['currentSite', 'currentCircuit']
}
</script>
<style scoped lang="scss">
.landscapeMask{
  -webkit-mask-image:
  radial-gradient(circle at center top, transparent 2.5vh, #000 2.5vh),
    radial-gradient(circle at center bottom, transparent 2.5vh, #000 2.5vh),

    radial-gradient(circle at center 7%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 12%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 18%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 23%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 29%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 34%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 39%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 45%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 50%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 55%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 61%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 66%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 72%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 77%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 83%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 88%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 93%, transparent 0.75vh, #000 0.75vh);
  mask-image: radial-gradient(circle at center top, transparent 2.5vh, #000 2.5vh),
    radial-gradient(circle at center bottom, transparent 2.5vh, #000 2.5vh),
    radial-gradient(circle at center 7%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 12%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 18%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 23%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 29%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 34%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 39%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 45%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 50%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 55%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 61%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 66%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 72%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 77%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 83%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 88%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at center 93%, transparent 0.75vh, #000 0.75vh);
  mask-composite: exclude !important;
  -webkit-mask-composite: destination-out;
  mask-repeat: no-repeat;
  mask-size: 100% 100%;

}
.portaitMask{
  -webkit-mask-image: radial-gradient(circle at left 80.3%, transparent 2.5vw, #000 2.5vw),
    radial-gradient(circle at right 80.3%, transparent 2.5vw, #000 2.5vw),
    radial-gradient(circle at 7% 80.3%,  transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 12% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 18% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 23% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 28% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 34% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 39% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 44% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 50% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 55% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 61% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 66% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 72% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 77% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 82% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 88% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 93% 80.3%, transparent 0.75vh, #000 0.75vh);
  mask-image: radial-gradient(circle at left 80.3%, transparent 2.5vw, #000 2.5vw),
    radial-gradient(circle at right 80.3%, transparent 2.5vw, #000 2.5vw),
    radial-gradient(circle at 7% 80.3%,  transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 12% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 18% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 23% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 28% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 34% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 39% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 44% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 50% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 55% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 61% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 66% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 72% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 77% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 82% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 88% 80.3%, transparent 0.75vh, #000 0.75vh),
    radial-gradient(circle at 93% 80.3%, transparent 0.75vh, #000 0.75vh);
  mask-composite: exclude !important;
  -webkit-mask-composite: destination-out;
  mask-repeat: no-repeat;
  mask-size: 100% 100%;
}
.q-mb-lg{
  margin-bottom: 3vh;
}
.q-mb-sm{
  margin-bottom: 1vh;
}
</style>
